module.exports = __webpack_public_path__ + "static/media/BusinessProcessManagementTools.4c557b7a.jpg";